import React, { useContext, useEffect, useState } from 'react'
import RegisterComponent from '@/views/Registration/RegisterComponent'
import RegistrationLayout from '../../custom/components/templates/AuthLayout'
import { mapData, handleRedirectInternal } from '../../product/common/components'
import ProductCommonContext from '../../product/context/common/commonContext'
import CustomCommonContext from '../../custom/context/common/commonContext'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import CommonContext from '../../custom/context/common/commonContext'
import AlertContext from '../../product/context/alert/alertContext'
import AuthContext from '../../product/context/auth/authContext'
import RadioBox from '../../product/components/atoms/RadioBox'
import CheckBox from '../../product/components/atoms/CheckBox'
import { useFormik, connect, Form, Formik } from 'formik'
import { FilterFramesOutlined } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import Backdrop from '@material-ui/core/Backdrop'
import { Button, Fade } from '@material-ui/core'

import { useHistory } from 'react-router-dom'
import { LOGO, SITE_NAME } from '../../utils'
import { Modal } from '@material-ui/core'
import { Link } from 'react-router-dom'
import { Document } from 'react-pdf'
import { stubFalse } from 'lodash'
import './Registration.css'
import * as Yup from 'yup'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import SEO from '@/utils/SEO'
import AuthLayout from '../../custom/components/templates/AuthLayout'
import SignContext from '@/custom/context/signContext'
import CustomDrawer from '@/custom/components/molecules/CustomDrawer'
import RegisterVerify from './RegisterVerify'
import moment from 'moment'
import Loaders from '@/custom/components/molecules/Loaders'

const useStyles = makeStyles((theme, maxWidth) => ({
    modal: {
        display: 'flex',
        padding: theme.spacing(1),
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        width: '100%',
        maxWidth: '55rem',
    },
}))

const Registration = (props) => {
    const classes = useStyles()

    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const history = useHistory()
    const customCommonContext = useContext(CustomCommonContext)
    const { setAlert } = alertContext
    const { register, responseStatus, clearResponse, loadUser } = authContext
    const {
        signupModal,
        setSignupModal,
        loginModal,
        setLoginModal,
        allOrganization,
        allConfigurationVariables,
    } = customCommonContext
    const { handleRegisterPopup } = useContext(SignContext)

    const commonContext = useContext(CommonContext)
    const productCommonContext = useContext(ProductCommonContext)
    const dynamicContext = useContext(DynamicContext)

    const { getAllDynamicArray, dynamicValue } = dynamicContext
    const [toggleSignup, setToggleSignup] = useState({
        popup: signupModal,
    })
    const [updatedValues, setUpdatedValues] = useState({})
    const [customValidation, setCustomValidation] = useState([])
    const [customValidationSeller, setCustomValidationSeller] = useState([])

    const [customInitialSeller, setCustomInitialSeller] = useState([])
    const [customInitialBuyer, setCustomInitialBuyer] = useState([])
    const [fieldValue, setFieldValue] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [sellerValue, setSellerValue] = useState([])
    const { configFeatures } = commonContext
    const { static_page, getStaticPage, allCountries, allStates } = productCommonContext
    let [termsLink, setTermsLink] = useState([])

    const [phoneVerify, setPhoneVerify] = useState(false)
    const [regType, setRegType] = useState(0)

    useEffect(() => {
        setToggleSignup({ popup: signupModal })
    }, [signupModal])

    // YUP Validation array to ensure all required fields are given values
    const SubmitBtnLable = 'Signup'

    useEffect(() => {
        getStaticPage({ id: 'terms_of_use' })
    }, [])

    useEffect(() => {
        setTermsLink(static_page?.record?.file_path ? static_page.record.file_path : null)
    }, [static_page])

    const viewTerms = () =>
        window.open(
            termsLink
                ? `${global.site_url}/uploads/static_files/${termsLink}`
                : '/assets/docs/termsOfService.pdf',
        )

    // Set Initial values

    useEffect(() => {
        getAllDynamicArray(
            {
                page: 1,
                limit: 20,
                order: 'asc',
                orderby: 'df.show_order',
                table: 'dynamic_fields',
                filters: {
                    action: {
                        value: 3,
                        type: 'in',
                        field: 'df.view_page',
                    },
                    forOrganization: {
                        value: 1,
                        type: 'in',
                        field: 'df.for_organization',
                    },
                    active: {
                        value: 1,
                        type: 'in',
                        field: 'df.active',
                    },
                },
            },
            'forOrganization',
        )
        getAllDynamicArray(
            {
                page: 1,
                limit: 20,
                order: 'asc',
                orderby: 'df.show_order',
                table: 'dynamic_fields',
                filters: {
                    action: {
                        value: 3,
                        type: 'in',
                        field: 'df.view_page',
                    },
                    forBuyer: {
                        value: 1,
                        type: 'in',
                        field: 'df.for_buyer',
                    },
                    active: {
                        value: 1,
                        type: 'in',
                        field: 'df.active',
                    },
                },
            },
            'forBuyer',
        )
    }, [])
    useEffect(() => {
        if (dynamicValue.from === 'forOrganization') {
            if (dynamicValue.records) {
                let dynamicValueAssign = []
                dynamicValue.records.map((item) => {
                    item.view_on
                        ? item.view_on.includes('7')
                            ? dynamicValueAssign.push(item)
                            : {}
                        : dynamicValueAssign.push(item)
                })
                dynamicValueAssign.push({
                    name: 'market_status',
                    value: 'draft',
                    type: 'default',
                    active: 1,
                })
                dynamicValueAssign.push({
                    label: (
                        <>
                            <p className="adultchk">
                                By signing up
                                {','} I agree to Zipperbuy{' '}
                                <Link to="/terms-and-conditions" target="_blank">
                                    Terms and Conditions and Privacy Policy
                                </Link>
                            </p>
                        </>
                    ),
                    name: 'terms_accepted',
                    type: 'checkbox',
                    placeholder: '',
                    class: 'col-12 auth-links-wrap',
                })
                dynamicValueAssign.map((ele) => {
                    if (ele.name === 'phone') {
                        ele.formatPhone = true
                    }
                    if (ele.name === 'additional_phone') {
                        ele.formatPhone = true
                    }
                    if (ele.name === 'license_expiry_date') {
                        ele.disablePast = true
                    }
                })
                setSellerValue(dynamicValueAssign)
                setIsLoading(false)
            }
        }
        if (dynamicValue.from === 'forBuyer') {
            if (dynamicValue.records) {
                let dynamicValueAssign = []
                dynamicValue.records.map((item) => {
                    item.view_on
                        ? item.view_on.includes('7')
                            ? dynamicValueAssign.push(item)
                            : {}
                        : dynamicValueAssign.push(item)
                })

                dynamicValueAssign.push(
                    // {
                    //     label: 'Mobile Phone Number*',
                    //     name: 'phone',
                    //     type: 'number',
                    //     placeholder: 'Enter your mobile phone number',
                    //     countryCodeEditable: false,
                    //     class: 'col-12 col-sm-6',
                    //     tooltiptitle:
                    //         'Please enter the mobile phone number without the country code.',
                    //     disableHoverListener: false,
                    // },
                    {
                        label: (
                            <>
                                <p className="adultchk">
                                    By signing up
                                    {','} I agree to Zipperbuy{' '}
                                    <Link to="/terms-and-conditions" target="_blank">
                                        Terms and Conditions and Privacy Policy
                                    </Link>
                                </p>
                            </>
                        ),
                        name: 'terms_accepted',
                        type: 'checkbox',
                        placeholder: '',
                        class: 'col-12 auth-links-wrap',
                    },
                    {
                        label: (
                            <>
                                <p className="adultchk">
                                    Yes{','} I want fun marketing emails about popular products and
                                    hot deals
                                </p>
                            </>
                        ),
                        name: 'marketing_emails',
                        type: 'checkbox',
                        placeholder: '',
                        class: 'col-12 auth-links-wrap',
                    },
                    // {
                    //     label: (
                    //         <>
                    //             <p className="adultchk">
                    //                 I consent to receive SMS notifications from Zipperbuy.
                    //             </p>
                    //         </>
                    //     ),
                    //     name: 'terms_accepted_sms',
                    //     type: 'checkbox',
                    //     placeholder: '',
                    //     class: 'col-12 auth-links-wrap',
                    // },
                )
                dynamicValueAssign.push({
                    name: 'market_status',
                    value: 'draft',
                    type: 'default',
                    active: 1,
                })
                // const temp = dynamicValueAssign.filter((item) => {
                //     return item.name != 'companyname'
                // })

                dynamicValueAssign.map((ele) => {
                    if (ele.name === 'phone') {
                        ele.formatPhone = true
                    }
                    if (ele.name === 'additional_phone') {
                        ele.formatPhone = true
                    }
                    if (ele.name === 'license_expiry_date') {
                        ele.disablePast = true
                    }
                })

                setFieldValue(dynamicValueAssign)
                setIsLoading(false)
            }
        }
    }, [dynamicValue])

    useEffect(() => {
        let customValidationTemp = {}
        let customInitial = {
            phone_verified: 0,
            termCheck: 0,
            status: 'active',
            admin: 0,
            custom_user_email_notification:
                allConfigurationVariables?.default_enabled_user_email_notifications ||
                '2,4,6,7,8,9',
            marketing_emails: true,
        }
        let customOrgInitial = {
            phone_verified: 0,
            termCheck: 0,
            admin: 1,
            organization: 1,
            status: 'active',
            emp_type: 'seller',
            license_expiry_date: '',
            custom_user_email_notification:
                allConfigurationVariables?.default_enabled_user_email_notifications ||
                '2,4,6,7,8,9',
            marketing_emails: true,
        }
        customValidationTemp = {
            email: Yup.string()
                .email('Invalid Email Format')
                .max(250, 'Maximum 250 Characters')
                .required('Required'),
            password: Yup.string()
                .matches(
                    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/,
                    'Password must include uppercase and lowercase letters, a number, and a special character.',
                )
                .min(8, 'Minimum 8 Characters')
                .required('Required'),
            resale_certificate: Yup.array().when('tax_number', {
                is: (end) => end && end.length > 0,
                then: Yup.array().required('Required!'),
            }),
            confirm_password: Yup.string()
                .oneOf([Yup.ref('password')], 'Password does not match')
                .required('Required'),
            first_name: Yup.string()
                .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for this field ')
                .min(2, 'Mininum 2 characters')
                .max(15, 'Maximum 15 characters')
                .required('Required!'),
            last_name: Yup.string()
                .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for this field ')
                .min(2, 'Mininum 2 characters')
                .max(15, 'Maximum 15 characters')
                .required('Required!'),
            // phone: Yup.string()
            //     .trim()
            //     .min(10, (obj) => {
            //         if (obj?.value?.length) {
            //             return 'Phone must be 10 digits'
            //         }
            //     })
            //     .max(10, (obj) => {
            //         if (obj?.value?.length) {
            //             return 'Phone must be 10 digits'
            //         }
            //     })
            //     .required('Required'),
            zip: Yup.string()
                .trim()
                .matches(/^[0-9]*$/g, 'Positive Numbers only')
                .max(6, 'Maximum 6 characters')
                .required('Required'),
            city: Yup.string()
                .trim()
                .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for this field ')
                .required('Required'),
            terms_accepted: Yup.boolean().oneOf([true], 'You must accept the terms and conditions'),
            // terms_accepted_sms: Yup.boolean().oneOf([true], 'You must accept the SMS consent'),
            marketing_emails: Yup.boolean(),
            additional_phone: Yup.string()
                .trim()
                .when('phone', {
                    is: (value) => value !== '+1',
                    then: Yup.string().notOneOf(
                        [Yup.ref('phone')],
                        'Mobile number and additional phone number should not be same',
                    ),
                    //    .min(17, 'Please enter correct mobile number'),
                })
                .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
                .nullable(),
            driver_license: Yup.string(),
            license_expiry_date: Yup.date().when('driver_license', {
                is: (end) => end && end.length > 0,
                then: Yup.date()
                    .transform((__, value) =>
                        value && typeof value === 'string'
                            ? new Date(
                                  moment(new Date(value.replace(/-/g, '/'))).subtract(1, 'minutes'),
                              )
                            : new Date(moment(value).subtract(1, 'minutes')),
                    )
                    .min(new Date(), 'Date must be greater than today')
                    .nullable()
                    .required('Required!'),
            }),
        }
        setCustomInitialSeller(customOrgInitial)
        setCustomInitialBuyer(customInitial)
        setCustomValidation(customValidationTemp)
    }, [])

    useEffect(() => {
        if (allConfigurationVariables?.default_enabled_user_email_notifications) {
            setCustomInitialBuyer({
                ...customInitialBuyer,
                custom_user_email_notification:
                    allConfigurationVariables?.default_enabled_user_email_notifications,
                marketing_emails: true,
            })
            setCustomInitialSeller({
                ...customInitialSeller,
                custom_user_email_notification:
                    allConfigurationVariables?.default_enabled_user_email_notifications,
                marketing_emails: true,
            })
        }
    }, [allConfigurationVariables?.default_enabled_user_email_notifications])

    // Mapped over for individual registration fields

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }

    const [drawerOpen, setDrawerOpen] = useState(false)
    const [email, setEmail] = useState('')
    const toggleDrawer = () => setDrawerOpen(!drawerOpen)

    const onSuccess = () => {
        loadUser()
        handleRegisterPopup()
        handleRedirectInternal(history, 'success')
    }

    return (
        <>
            <SEO
                title="Register"
                description="Shop on Zipperbuy - Find great deals. Buy now or make offers on new, overstock, open-box, and returned items. Shop local, save money."
                keywords="deals, buy now, overstock, open-box, returned items, shop local, shopping, marketplace, auctions, offers"
                url={window.location.href}
            />
            {isLoading ? (
                <Loaders isLoading={true} name={'home'} />
            ) : (
                <AuthLayout
                    title="Create a Zipperbuy Account"
                    authNote="Already have an account?"
                    // authLink="/login"
                    authText="Sign in"
                    seperatorText="Or Sign up with"
                    formClass="auth-container sign-up-wrapper"
                >
                    {' '}
                    <RegisterComponent
                        fieldValue={fieldValue}
                        customInitial={customInitialBuyer}
                        customValidation={customValidation}
                        additionalFieldUpdate={additionalFieldUpdate}
                        SubmitBtnLable={SubmitBtnLable}
                        formatPhone={true}
                        phoneField={['phone', 'additional_phone']}
                        facebookSignUp={true}
                        onSuccess={onSuccess}
                        // phoneVerify={true}
                        googleSignUp={true}
                        project="true"
                        // emailVerify={true}
                        formatCustomDate={true}
                        userNameVerify={true}
                        formatCustomDateFields={['license_expiry_date']}
                        registerUniqueEmail={true}
                        autoRegisterAfterVerify={true}
                    />
                    <CustomDrawer
                        toggleDrawer={toggleDrawer}
                        anchor="right"
                        open={drawerOpen}
                        className="custom-drawer register-drawer"
                    >
                        <RegisterVerify email={email} />
                    </CustomDrawer>
                </AuthLayout>
            )}
        </>
    )
}

export default Registration
